import axios from 'axios';
import {ENDPOINT_URL, GET_ROLES_LIST} from '../../../constants/commonConstants';
import {decodeAgentResponse} from '../../core/resolutionUtils';

// The category codes the roles API returns per row - the same mapping
// roles.jsx already applies inline when opening a role for edit
// (1 = Read Only, 2 = Admin, 3 = Privileged/"Previleged").
const CATEGORY_KEYS = {
	1: 'read_only',
	2: 'admin',
	3: 'privileged',
};

/**
 * Build the roles list URL for a given page/search.
 * @param {number} limit page size
 * @param {number} offset page offset
 * @param {string} [search] optional search term
 * @return {string} request URL
 */
function buildRolesUrl(limit, offset, search) {
	let url = `${ENDPOINT_URL}${GET_ROLES_LIST}?limit=${limit}&offset=${offset}`;
	if (search) url += `&search=${encodeURIComponent(search)}`;
	return url;
}

/**
 * Role counts by category.
 *
 * The roles API has no category filter, so - like user status counts - the
 * total is probed with a 1-row request first (exact `count`, no guessing a
 * page size), then that exact count is requested once and tallied
 * client-side by each row's numeric `category` field.
 * @param {object} command semantic statistic command
 * @return {Promise<{values: {total: number, read_only: number, admin: number, privileged: number}}>} counts
 */
export async function readRoleCategoryCounts(command = {}) {
	const search = command.params?.query;
	const {data: probeData} = await axios.get(buildRolesUrl(1, 0, search));
	const total = Number(decodeAgentResponse(probeData)?.count) || 0;
	const counts = {read_only: 0, admin: 0, privileged: 0};
	if (total === 0) {
		return {values: {total: 0, ...counts}};
	}
	const {data} = await axios.get(buildRolesUrl(total, 0, search));
	const rows = decodeAgentResponse(data)?.results;
	if (Array.isArray(rows)) {
		rows.forEach((row) => {
			const key = CATEGORY_KEYS[Number(row?.category)];
			if (key) counts[key] += 1;
		});
	}
	return {values: {total, ...counts}};
}
